<!-- 月台管理界面 -->
<template>
  <div class="plat-manage-box">
    <div class="left-box">
      <el-tree class="filter-tree" :data="treeData" :props="defaultProps" default-expand-all ref="tree" :expand-on-click-node="false" @node-click="handleNodeClick" highlight-current node-key="id"></el-tree>
    </div>
    <div class="right-box access-record-container">
      <!--主页面 -->
      <div class="flex-row" style="height: 100%">
        <div class="flex-auto flex-valign" style="overflow: hidden">
          <div class="section-main_table" style="flex-direction: column">
            <ioc-table ref="storageTab" :data="tableData" :option="tableOption" :page="page" @current-change="selectPage" @size-change="changeSize" @selection-change="handleSelectionChange">
              <!-- 上方按钮 -->
              <template slot="menuLeft">
                <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAddPlat">
                  新增
                </el-button>
                <el-button size="small" class="iss-operation-button" icon="el-icon-delete" @click="handelDeletePlats">
                  批量删除
                </el-button>
              </template>
              <!-- 启用状态栏 -->
              <template slot="platformStatus" slot-scope="scope">
                <el-switch v-model="scope.row.platformStatus" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="changePlatStatus(scope.row)">
                </el-switch>
              </template>
              <!-- 操作栏 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont icon-xiugai" @click="handleUpdatePlat(scope.row, scope.index)"></el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="iconfont el-icon-delete" @click="handelDeleteSinglePlat(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <!--新增/修改-->
    <appPanel :width="750" class="app-panel" :isExpand="showPanel" @cancel="handleClosePanel" :title="title">
      <!-- 内容区域 -->
      <div>
        <el-form style="height: 99%; position: absolute; width: 100%" :inline="true" :model="platFromInfo" :rules="platFromRule" ref="platForm" label-width="96px" label-position="right" label-suffix=" :">
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="12">
                <el-form-item label="编号" prop="platformCode">
                  <el-input v-model="platFromInfo.platformCode" placeholder="请输入编号" clearable :disabled="isUpdate">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="名称" prop="platformName">
                  <el-input v-model="platFromInfo.platformName" placeholder="请输入名称" clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="分组" prop="platformGroupName">
                  <el-select v-model="platFromInfo.platformGroupName" placeholder="请选择分组" clearable>
                    <el-option v-for="item in platformGroupArr" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="绑定相机" prop="cameraName">
                  <el-input v-model="platFromInfo.cameraName" placeholder="请选择绑定相机" clearable @click.native="deviceSelect">
                    <i slot="suffix" @click="deviceSelect" class="el-input__icon el-icon-more" style="cursor: pointer;"></i></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>
      <!-- 按钮区域 -->
      <div slot="footer" class="dialog-footer" style="margin-bottom: 18px;">
        <el-button @click="handleClosePanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSavePanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </div>
    </appPanel>
    <DeviceSelect ref="deviceSelect" @selectArr="receiveDevice" :selectCamera="selectCamera"></DeviceSelect>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/table";
import DeviceSelect from "../components/deviceSelect.vue";
export default {
  components: {
    appPanel,
    DeviceSelect,
  },
  data() {
    return {
      form: {},
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 选择的platId
      checkedPlatIds: [],
      // 树数据
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 新增或修改
      subLoading: false,
      title: "",
      showPanel: false,
      platFromInfo: {
        platformId: undefined,
        platformCode: "",
        platformName: "",
        cameraCode: "",
        cameraName: "",
        platformGroupName: "",
      },
      isUpdate: false,
      platFromRule: {
        platformCode: [
          {
            required: true,
            message: "请输入编号",
            trigger: ["blur", "change"],
          },
        ],
        platformName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      currentId: null,
      selectCamera: "",
      platformGroupArr: [],
    };
  },
  mounted() {
    this.getStorageList();
  },
  beforeDestroy() {},
  methods: {
    deviceSelect() {
      if (this.platFromInfo.cameraCode != "") {
        this.selectCamera = this.platFromInfo.cameraCode;
      }
      this.$refs.deviceSelect.openDialog();
    },
    receiveDevice(val) {
      this.platFromInfo.cameraName = val.deviceName;
      this.platFromInfo.cameraCode = val.deviceId;
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 冷库管理列表数据
    getStorageList() {
      let params = {
        pageNum: 1,
        pageSize: 1000,
      };
      this.$fetch(api.storage.queryColdStorageList, params).then((response) => {
        if (response.success) {
          const storageData = response.returnObj.list;
          const childrenData = storageData.map((item) => {
            return {
              id: item.storageId,
              label: item.storageName,
              storageGroupNames: item.storageGroupNames,
            };
          });
          this.treeData = [
            {
              id: 1,
              label: "冷库",
              children: childrenData,
            },
          ];
          this.platformGroupArr = [];
          this.$nextTick(() => {
            if (storageData[0].storageGroupNames) {
              let storageNameArr = storageData[0].storageGroupNames.split(",");
              for (let i = 0; i < storageNameArr.length; i++) {
                this.platformGroupArr.push({
                  label: storageNameArr[i],
                  value: storageNameArr[i],
                });
              }
            }
            this.currentId = storageData[0].storageId;
            this.$refs.tree.setCurrentKey(this.currentId);
            this.getList();
          });
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 树节点点击事件
    handleNodeClick(data) {
      if (data.id == 1) {
        this.currentId = "";
      } else {
        this.currentId = data.id;
        this.platformGroupArr = [];
        if (data.storageGroupNames) {
          let storageNameArr = data.storageGroupNames.split(",");
          for (let i = 0; i < storageNameArr.length; i++) {
            this.platformGroupArr.push({
              label: storageNameArr[i],
              value: storageNameArr[i],
            });
          }
        }
      }
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.getList();
    },
    // 冷库管理列表数据
    getList() {
      let params = {
        storageId: this.currentId,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      this.$fetch(api.platform.queryPlatformList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.storageTab.selectClear();
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAddPlat() {
      this.isUpdate = false
      this.title = "新增月台信息";
      this.showPanel = true;
      this.platFromInfo.platformId = undefined;
      this.platFromInfo.platformName = "";
      this.platFromInfo.platformCode = "";
      this.platFromInfo.cameraName = "";
      this.platFromInfo.cameraCode = "";
      this.platFromInfo.platformGroupName = "";
      this.selectCamera = "";
    },
    handleUpdatePlat(row, index) {
      this.isUpdate = true
      this.title = "修改月台信息";
      this.showPanel = true;
      this.platFromInfo = row;
    },

    handleSelectionChange(items) {
      if (!items || !items.length) {
        this.checkedPlatIds = [];
      } else {
        this.checkedPlatIds = items.map((item) => {
          return item.platformId;
        });
      }
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handelDeleteSinglePlat(row) {
      this.$confirm("您确定删除该月台数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.platform.delPlatformList, {
          ids: [row.platformId],
          storageId: this.currentId == "" ? null : this.currentId,
        }).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList();
        });
      });
    },
    handelDeletePlats() {
      if (this.checkedPlatIds.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择需要删除的月台数据",
        });
        return;
      }
      this.$confirm("您确定要删除选中的月台数据吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$fetch(api.platform.delPlatformList, {
            ids: this.checkedPlatIds,
            storageId: this.currentId == "" ? null : this.currentId,
          }).then((response) => {
            if (!response.success) {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            } else {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            }
            this.getList();
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 改变月台状态
    changePlatStatus(val) {
      if (val.platformStatus == 1) {
        // 开启状态
        this.$confirm("您确定开启该月台吗?", "开启确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$fetch(api.platform.updatePlatformList, {
              storageId: this.currentId,
              platformId: val.platformId,
              platformStatus: 1,
              platformCode: val.platformCode,
            }).then((response) => {
              if (response && response.success) {
                this.$message({
                  message: "开启成功",
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: response.msgContent,
                  type: "error",
                  duration: 2000,
                });
              }
              this.getList();
            });
          })
          .catch(() => {
            this.getList();
          });
      } else {
        // 关闭状态
        this.$confirm("您确定关闭该月台吗?", "关闭确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$fetch(api.platform.updatePlatformList, {
              storageId: this.currentId,
              platformId: val.platformId,
              platformStatus: 2,
              platformCode: val.platformCode,
            }).then((response) => {
              if (response && response.success) {
                this.$message({
                  message: "关闭成功",
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: response.msgContent,
                  type: "error",
                  duration: 2000,
                });
              }
              this.getList();
            });
          })
          .catch(() => {
            this.getList();
          });
      }
    },
    // 取消新增/修改
    handleClosePanel() {
      this.showPanel = false;
      this.handleRestForm();
      // 刷新列表数据
      this.getList();
    },
    // 保存新增/修改
    handleSavePanel() {
      this.$refs.platForm.validate((valid) => {
        if (valid) {
          let params = { ...this.platFromInfo };
          params.storageId = this.currentId;
          if (params.platformId) {
            // 修改
            this.$fetch(api.platform.updatePlatformList, params).then((res) => {
              if (res.msgCode == "0") {
                this.$message({
                  message: "修改成功",
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: "修改失败",
                  type: "error",
                  duration: 2000,
                });
              }
              // 关闭弹窗
              this.showPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getList();
            });
          } else {
            // 新增
            this.$fetch(api.platform.addPlatformList, params).then((res) => {
              if (res.msgCode == "0") {
                this.$message({
                  message: "新增成功",
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$message({
                  message: "新增失败",
                  type: "error",
                  duration: 2000,
                });
              }
              // 关闭弹窗
              this.showPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              this.getList();
            });
          }
        } else {
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.platFromInfo.platformId = undefined;
      this.platFromInfo.platformName = "";
      this.platFromInfo.platformCode = "";
      this.platFromInfo.cameraName = "";
      this.platFromInfo.platformGroupName = "";
      this.$refs["platForm"].clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.plat-manage-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  .left-box {
    width: 360px;
    height: 100%;
    // margin-right: 15px;
    padding: 10px 16px 0 16px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .title-box {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      // color: #fff;
      color: #000000;
      border-left-width: 3px;
      border-left-style: solid;
      padding-left: 10px;
      border-left-color: #407aee;
      position: relative;
    }

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 10px;

      .content-item {
        width: 85%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }

      .content-border-item {
        width: 85%;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid white;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #407aee;
      }

      :active {
        background: #407aee;
      }

      .content-selected-item {
        background: #407aee;
      }
    }
  }

  .access-record-container {
    width: 100%;
    height: 100%;

    .query {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include set_theme_color(background-color, left-menu-bg-color);
      padding: 10px 16px 3px;

      .el-form-item {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 8px !important;
        vertical-align: top;
      }
    }

    .el-table__fixed-right-patch {
      display: none;
    }

    .el-dialog {
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }

  .right-box {
    width: calc(100% - 376px);
    height: 100%;

    ::v-deep .ioc-table__menu {
      margin-top: 0px !important;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>

<style>
/* .plat-manage-box .el-tree-node {
  height: 30px !important;
  line-height: 30px !important;
  margin: 10px;
} */
.plat-manage-box .el-tree-node__content {
  height: 40px !important;
  line-height: 40px !important;
  margin: 5px;
}
</style>